<script setup>
import KpiCard from './KpiCard.vue';

defineProps({
  metrics: {
    type: Object,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  loadingMessage: {
  type: String,
  default: '',
  },
});
  
const getBgClass = (index) => {
  const bgClasses = ['bg-[#D1FADF]', 'bg-[#FEF0C7]', 'bg-[#F5F5F5]'];
  return bgClasses[index] || 'dark:bg-n-vars-black-br/30';
};

const getChangePercent = (index) => {
  const changes = [40, 40, 40];
  return changes[index] || 0;
};
</script>

<template>
  <div class="grid grid-cols-3 gap-[6px] lg:gap-4">
    <KpiCard
      v-for="(metric, name, index) in metrics"
      :key="index"
      :title="name"
      :value="metric"
      :is-loading="isLoading"
      :bg-class="getBgClass(index)"
      text-class="!text-n-gray-6"
      title-class="!text-n-gray-9"
      :show-chart="false"
    />
  </div>
</template>